module.exports = __webpack_public_path__ + "Cambio.bf8e98bb5785ce3404549f7286eedf5f.png";